module.exports = __webpack_public_path__ + "img/logo.1c8c57cd.png";